import Vue from 'vue'
import App from './App.vue'

import router from './router'
import VueCookie from 'vue-cookie'
import Vant from 'vant';
import 'vant/lib/index.css';
import { Lazyload } from 'vant';
import flow from '@/utils/flow';
import util from '@/utils/index';
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import screenButton from '@/components/screenButton/screenButton'



import httpRequest from './utils/httpRequest.js'
// import MessageBox from './components/MessageBox/message.js'
// 水印
import watermark from './utils/watermark.js'
import {viewAttach} from './utils/common.js'
// 只引入图标css，不 import ElementUI、不 Vue.use(ElementUI)
import 'element-ui/lib/theme-chalk/icon.css'

Vue.prototype.$http = httpRequest // ajax请求方法
Vue.prototype.$watermark = watermark
Vue.config.productionTip = false
Vue.prototype.$flow = flow
Vue.prototype.$util = util
Vue.prototype.$viewAttach = viewAttach
Vue.component('screenButton', screenButton)
Vue.use(BootstrapVue)
Vue.use(VueCookie)
// Vue.use(MessageBox)
Vue.use(Vant);
Vue.use(Lazyload, {
  lazyComponent: true,
});


// 添加导航守卫
router.beforeEach((to, from, next) => {
  // 使用 meta 字段中的 title
  if (to.meta.title) {
    document.title = to.meta.title;
  } else {
    document.title = '金桥审批中心'; // 默认标题
  }
  next();
});


new Vue({
  render: h => h(App),
  router,
}).$mount('#app')
